/**
 * 获取当前运行环境
 * @returns {string} 'production' | 'test' | 'development'
 */
function getEnvironment() {
  const host = window.location.hostname;

  // 本地开发环境
  if (host === 'localhost' || host === '127.0.0.1' || host.startsWith('192.168.')) {
    return 'development';
  }

  if (
    host.includes('.jeachou')
  ) {
    return 'test';
  }

  // 正式环境：默认
  return 'production';
}

/**
 * 根据环境获取对应的 API 地址
 * @param {string} env - 环境标识
 * @returns {string} API 地址
 */
function getApiUrl(env) {
  const config = {
    production: 'https://api.luminousvc.com/admin',
    test: 'http://luminous2.api.jeachou.com/admin',
    development: 'http://luminous2.api.jeachou.com/admin', // 本地开发也用测试环境
  };
  return config[env] || config.production;
}

const currentEnv = getEnvironment();
const api_url = getApiUrl(currentEnv);

import axios from "axios";


const OSS = require("ali-oss");

async function getSts() {
  const res = await axios.post(api_url + "/Oss/getToken", {});
  return res.data;  // { accessKeyId, accessKeySecret, securityToken, region, bucket, prefix, cdnUrl }
}

// 2. 用临时凭证直传
async function upload(file) {
  const sts = await getSts();
  const client = new OSS({
    region: sts.region,
    accessKeyId: sts.accessKeyId,
    accessKeySecret: sts.accessKeySecret,
    stsToken: sts.securityToken,   // 关键：临时凭证必须带 stsToken
    bucket: sts.bucket,
  });
  const key = `${sts.prefix}${Date.now()}_${file.name}`;
  await client.put(key, file);
  return sts.cdnUrl ? `${sts.cdnUrl}/${key}` : (await client.signatureUrl(key));
}

const formatNumber = n => {
  n = n.toString();
  return n[1] ? n : "0" + n;
};

const formatTime = (date, e) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  if (e == 1) {
    return (
      [year, month, day].map(formatNumber).join("-") +
      " " +
      [hour, minute, second].map(formatNumber).join(":")
    );
  } else if (e == 2) {
    return [year, month, day].map(formatNumber).join(".");
  } else if (e == 3) {
    return [year, month, day].map(formatNumber).join("-");
  } else if (e == 4) {
    return year + "" + month + "" + day;
  }
};

var toTop = function () {
  document.getElementsByClassName("ant-layout")[1].scrollTop = 0;
};

export default {
  upload,
  api_url,
  formatTime,
  toTop
};



// WEBPACK FOOTER //
// ./src/util/common.js